import styled from "styled-components/macro";

export const StyledJobListing = styled.div`
  .paper-texture {
    background: url("/assets/paper-texture-mild.jpg");
    /* background-size: 1000px;
    position: absolute;
    width: 100%;
    min-height: 100%;
    opacity: 20%;
    z-index: 0; */
  }
  section {
    padding-bottom: 2vw;
    padding-top: 2vw;
    background: rgba(245, 242, 228, 0.5);
    #mobile-header {
      display: none;
    }
    #write-icon {
      padding-top: 64px;
      width: 24px;
    }
    .italic {
      font-style: italic;
    }
    .emphasis {
      font-weight: 700;
      color: #610101;
    }
    .subheader {
      font-weight: 800;
      font-size: 32px;
      width: 900px;
      margin: 50px 0 40px 0;
      text-align: center;
      line-height: 150%;
    }
    h3 {
      font-family: "Inter";
      font-size: 14px;
      line-height: 130%;
      text-align: center;
      font-weight: 600;
      color: #f9423a;
      letter-spacing: 1px;
      padding-bottom: 2vw;
      padding-top: 2vw;
    }
    h1 {
      font-family: "GT Super Text";
      font-size: 12vw;
      font-weight: 300;
      text-align: center;
      max-width: 90vw !important;
      color: #212024;
      margin-bottom: 0px;
    }
    h2 {
      font-family: "GT Super Text";
      font-size: 3.5vw;
      line-height: 130%;
      margin: 0 4vw 0 4vw;
      font-weight: 300;
      text-align: center;
      padding: 1vw 4vw;
    }
    p {
      font-family: "GT Super Text";
      font-size: 26px;
      line-height: 140%;
      width: 700px;
      font-weight: 400;
      text-align: left;
    }
    a {
      color: #212024 !important;
      text-decoration: underline;
    }
    li {
      font-family: "GT Super Text";
      font-size: 26px;
      line-height: 140%;
      max-width: 700px;
      font-weight: 400;
      text-align: left;
      list-style: square;
      margin-bottom: 18px;
    }
    ol {
      margin-bottom: -18px;
    }
    li::marker {
      color: rgba(49, 178, 0, 1);
    }
  }
  #listing {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      font-size: 11.5vw;
      width: 95%;
      padding: 8vw 0 6vw 0;
      line-height: 100%;
    }
  }
  @media (max-width: 900px) {
    section {
      p {
        font-size: 20px; // Decrease size for tablet
        width: 85%;
        max-width: 600px;
      }
      .subheader {
        font-size: 28px; // Decrease size for tablet
        width: 96%;
        max-width: 98%;
      }
      ul,
      ol {
        width: 550px;
      }
      li {
        font-size: 20px;
      }
    }
  }

  @media (max-width: 600px) {
    section {
      #desktop-header {
        display: none;
      }
      #mobile-header {
        display: block;
        #line1 {
          font-size: 17vw;
        }
        #line2 {
          font-size: 23vw;
          margin-top: -2vw;
        }
        #line3 {
          font-size: 25vw;
          margin-top: -3vw;
          margin-bottom: 2vw;
        }
      }
      p {
        font-size: 18px; // Decrease size for mobile
        width: 85%;
      }
      .subheader {
        font-size: 21px; // Decrease size for mobile
        width: 95%;
        margin: 25px 0 15px 0;
      }

      h2 {
        font-size: 7vw;
        /* font-size: 5.1vw; */
        margin: 0;
        /* margin: 0px 1vw; */
        padding: 2vw 2vw;
      }
      ul,
      ol {
        width: 80%;
      }
      li {
        font-size: 18px;
      }
    }
  }
`;

export const StyledNav = styled.nav`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: #f5f2e4;

  img {
    padding: 24px;
    width: 80px;
    opacity: 0.5;
  }

  ul {
    list-style-type: none;

    li {
      display: inline-block;
      font-family: "Inter";
      font-weight: 500;
      padding: 24px 5px 24px 24px;

      &:last-child {
        padding-right: 36px;
      }

      a {
        color: #2b2315;
        opacity: 0.5;
      }
    }
  }
`;
